var _circle, _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHappyGoStayKey = function SvgHappyGoStayKey(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "inherit",
    height: "inherit",
    fill: "none",
    viewBox: "0 0 66 25"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.947,
    cy: 8.135,
    r: 5.135,
    fill: "url(#happyGoStayKey_svg__a)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E9F6EA",
    d: "m23.804 7.626-.2.756h-3.561l.203-.756zm-1.88 4.092L20.151 9.61l-.004-.684h.88a.86.86 0 0 0 .466-.117.7.7 0 0 0 .275-.316q.09-.198.09-.443 0-.25-.082-.44a.6.6 0 0 0-.264-.305q-.18-.113-.489-.113h-.977l.233-.952h.744q.678 0 1.133.204.458.203.688.59.233.384.233.925 0 .478-.147.835a1.4 1.4 0 0 1-.455.595q-.308.233-.808.353l1.583 1.918v.057zm1.884-5.477-.2.76h-2.963l.199-.76z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#happyGoStayKey_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#happyGoStayKey_svg__c)",
    fillRule: "evenodd",
    d: "M12.07 8.4v-.766q0-.918-.54-1.565-.54-.648-1.403-.648-.986 0-1.55.775-.563.775-.563 2.185 0 1.21.535 1.915t1.465.704q.92 0 1.489-.714.567-.714.567-1.886M15 11.945q0 2.695-1.55 4.175-1.548 1.48-4.487 1.48-1.944 0-3.08-.558v-2.515q1.483.87 2.995.87 1.502 0 2.329-.8.826-.799.826-2.17v-.766h-.038Q10.982 13.288 9 13.288q-1.84 0-2.92-1.305T5 8.483q0-2.457 1.202-3.905t3.164-1.447q1.755 0 2.63 1.362h.037V3.368H15z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#happyGoStayKey_svg__d)",
    fillRule: "evenodd",
    d: "M60.456 12v.758h-.544v2.045h-.806v-1.559H58.3v1.236h-.644v-1.195h-.645v.668h-.463v-1.154H29.844v.486h-.393v-1.681h.403v.405z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#happyGoStayKey_svg__e)",
    d: "M30.086 10.492V8.783q.464.39 1.007.585t1.097.195q.325 0 .568-.06.242-.058.405-.162a.7.7 0 0 0 .242-.245.666.666 0 0 0-.047-.708 1.4 1.4 0 0 0-.349-.326 4 4 0 0 0-.524-.288q-.304-.14-.656-.283-.895-.375-1.335-.913-.44-.54-.44-1.303 0-.598.24-1.028t.653-.708.956-.408Q32.448 3 33.054 3q.597 0 1.058.071.46.073.85.222v1.598a2.4 2.4 0 0 0-.419-.234 3.529 3.529 0 0 0-1.393-.3q-.294 0-.534.057a1.4 1.4 0 0 0-.404.157.8.8 0 0 0-.257.243q-.09.14-.09.317a.6.6 0 0 0 .101.344q.102.152.288.29.186.135.453.266.266.131.602.271.459.192.823.408.365.216.626.488.26.273.4.623a2.2 2.2 0 0 1 .138.814q0 .642-.242 1.076a1.95 1.95 0 0 1-.658.705q-.416.27-.966.387a5.6 5.6 0 0 1-1.164.118q-.63 0-1.196-.106a3.6 3.6 0 0 1-.984-.323"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#happyGoStayKey_svg__f)",
    d: "M41.593 4.531h-2.179v6.255h-1.727V4.53H35.52V3.126h6.074z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#happyGoStayKey_svg__g)",
    fillRule: "evenodd",
    d: "M47.147 10.786h1.876l-2.716-7.659h-2.04l-2.783 7.66h1.864l.539-1.704h2.717zm-.938-3.03-.82-2.574a3.2 3.2 0 0 1-.128-.689h-.042a3 3 0 0 1-.134.668l-.832 2.595z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#happyGoStayKey_svg__h)",
    d: "m55.41 3.127-2.49 4.935v2.724H51.2V8.094l-2.424-4.968h1.966l1.23 2.858q.033.08.178.625h.02q.07-.385.167-.604l1.251-2.879h1.822"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#happyGoStayKey_svg__i)",
    d: "M55.604 10.492V8.783q.465.39 1.007.585.543.195 1.098.195.325 0 .566-.06.243-.058.405-.162a.7.7 0 0 0 .242-.245.673.673 0 0 0-.047-.708 1.4 1.4 0 0 0-.35-.326A3.7 3.7 0 0 0 58 7.774q-.303-.14-.655-.283-.894-.375-1.334-.913-.439-.54-.44-1.303 0-.598.24-1.028t.652-.708.956-.408Q57.963 3 58.569 3q.597 0 1.059.071.46.073.85.222v1.598a2.4 2.4 0 0 0-.418-.234 3.47 3.47 0 0 0-1.393-.3q-.294 0-.534.057-.239.056-.404.157a.8.8 0 0 0-.256.243.57.57 0 0 0-.091.317q0 .192.102.344.1.152.287.29.188.135.453.266.266.131.602.271.458.192.824.408.363.216.626.488.261.273.398.623.139.349.139.814 0 .642-.241 1.076a2 2 0 0 1-.66.705q-.413.27-.966.387a5.6 5.6 0 0 1-1.164.118q-.629 0-1.196-.106a3.6 3.6 0 0 1-.983-.323"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "happyGoStayKey_svg__a",
    x1: 32.217,
    x2: 21.947,
    y1: 8.135,
    y2: -2.135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF3A5C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "happyGoStayKey_svg__c",
    x1: 20.001,
    x2: 6.466,
    y1: 10.366,
    y2: 1.011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF3A5C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "happyGoStayKey_svg__d",
    x1: 75.958,
    x2: 75.305,
    y1: 13.203,
    y2: 6.874,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF3A5C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "happyGoStayKey_svg__e",
    x1: 37.918,
    x2: 30.626,
    y1: 6.961,
    y2: 2.135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF3A5C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "happyGoStayKey_svg__f",
    x1: 44.63,
    x2: 37.172,
    y1: 6.956,
    y2: 1.042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF3A5C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "happyGoStayKey_svg__g",
    x1: 52.792,
    x2: 45.134,
    y1: 6.957,
    y2: -0.581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF3A5C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "happyGoStayKey_svg__h",
    x1: 58.727,
    x2: 51.145,
    y1: 6.956,
    y2: 0.389,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF3A5C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "happyGoStayKey_svg__i",
    x1: 63.434,
    x2: 56.143,
    y1: 6.961,
    y2: 2.136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF3A5C"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "happyGoStayKey_svg__b",
    width: 64.365,
    height: 23.152,
    x: 0.724,
    y: 0.862,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.138
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.138
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_509_16330"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_509_16330",
    result: "shape"
  })))));
};
export default SvgHappyGoStayKey;